import React from "react";
import classes from "./ErrorPage.module.css";
import { Sidebar } from "../layout/Sidebar/Sidebar";
import Footer from "../layout/footer/footer";
const ErrorPage = (props) => {
  return (
    <React.Fragment>
      <main>
        <Sidebar />
        <div className={classes["error-wrap"]}>
          <div>
            <h3>Oops, You are looking for something that does not exist.</h3>
            <p>404 Not Found.</p>
          </div>
        </div>
        <Footer />
      </main>
    </React.Fragment>
  );
};
export default ErrorPage;
